import React from "react";
import { BillsActionBarSkeleton } from "@features/skeletons/Bills/BillsActionBarSkeleton/BillsActionBarSkeleton";
import { ButtonSkeleton } from "@features/skeletons/common/ButtonSkeleton/ButtonSkeleton";
import { PageLayoutSkeleton } from "@features/skeletons/common/PageLayoutSkeleton/PageLayoutSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface IDefaultPageSkeleton {
  blocksCount?: number;
  blockSize?: number;
}

export const DefaultPageSkeleton: React.FC<IDefaultPageSkeleton> = ({
  blocksCount,
  blockSize,
}) => {
  return (
    <PageLayoutSkeleton actionBarSkeleton={<BillsActionBarSkeleton />}>
      <>
        <div className="px-4 pb-10 sm:hidden md:pb-4">
          <ButtonSkeleton className="w-full" />
        </div>
        <div className="mx-0 flex w-full flex-col gap-12">
          {Array(blocksCount ?? 2)
            .fill(0)
            .map((__, blockIndex) => (
              <div key={`bl-${blockIndex}`} className="flex flex-col gap-6">
                {Array(blockSize ?? 4)
                  .fill(0)
                  .map((_, index) => (
                    <Skeleton
                      key={`sk-${index}`}
                      className="h-6 w-full"
                      variant="rounded"
                    />
                  ))}
              </div>
            ))}
        </div>
      </>
    </PageLayoutSkeleton>
  );
};
